<button class="close-button" mat-icon-button (click)="cancel()">
    <mat-icon>close</mat-icon>
</button>

<h2 mat-dialog-title *ngIf="title">{{ title }}</h2>
<mat-dialog-content>
    <p [innerHtml]="bodyHtml"></p>
</mat-dialog-content>
<mat-dialog-actions align="center" *ngIf="confirm">
    <button class="medium-round" mat-raised-button (click)="assent()">{{ confirm }}</button>
</mat-dialog-actions>
